<template>
  <div class="container">
    <p>Select the plans to be transferred and provide the number of participants and dates.</p>

    <table class="fixed-table-header table table-sm table-condensed">
      <thead>
        <tr>
          <th>Select</th>
          <th>Plan</th>
          <th># Participants</th>
          <th>Original Effective Date</th>
          <th>Takeover Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(plan, index) in takeoverPlans" :key="index">
          <td class="align-middle align-items-center">
            <amf-checkbox label="" v-model="changedTakeoverPlans[index].selected"></amf-checkbox>
          </td>
          <td class="align-middle">{{changedTakeoverPlans[index].planType}}</td>
          <td>
            <div id="participants">
              <amf-input
                inputType="number"
                v-model="changedTakeoverPlans[index].participants">
              </amf-input>
            </div>
          </td>
          <td id="original-effective-date" class="col-3 align-middle">
            <div>
              <amf-datepicker
                :hide-calendar="true"
                style="max-width: 100%"
                v-model="changedTakeoverPlans[index].originalEffectiveDate">
              </amf-datepicker>
            </div>
          </td>
          <td id="takeover-date" class="col-3 align-middle">
            <amf-datepicker
              :hide-calendar="true"
              style="max-width: 100%"
              v-model="changedTakeoverPlans[index].takeoverDate">
            </amf-datepicker>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import {romeApi} from "../framework";
import AmfDatepicker from "../framework/primitives/AmfDatepicker.vue";
import AmfInput from "../framework/primitives/AmfInput.vue";
import AmfCheckbox from "../framework/primitives/AmfCheckbox.vue";

export default ({
  props: ["employerId", "orderId"],
  components: {AmfDatepicker, AmfInput, AmfCheckbox},
  data() {
    return {
      takeoverPlans: [],
      changedTakeoverPlans: []
    };
  },
  computed: {
    title() {
      return "Employer Transfer Plans"
    },
    buttons() {
      return 'Save/Cancel';
    }
  },
  async created() {
    await this.getTakeoverPlans();
  },
  methods: {
    async getTakeoverPlans() {
      this.takeoverPlans = await romeApi.get(`employer/${this.employerId}/order/${this.orderId}/takeover-plan`);

      for (const idx in this.takeoverPlans) {
        this.changedTakeoverPlans[idx] = {
          selected: false,
          planType: this.takeoverPlans[idx],
          participants: undefined,
          originalEffectiveDate: undefined,
          takeoverDate: undefined
        }
      }
    },
    async save() {
      let takeoverPlanRequested = [];

      this.changedTakeoverPlans.forEach((plan) => {
        if (!plan.selected) return;

        let newTakeoverPlanRequest = {
          planType: plan.planType,
          participants: plan.participants,
          originalEffectiveDate: plan.originalEffectiveDate,
          takeoverDate: plan.takeoverDate
        };

        takeoverPlanRequested.push(newTakeoverPlanRequest);
      });

      if (takeoverPlanRequested.length > 0) {
        await romeApi.post(`employer/${this.employerId}/order/${this.orderId}/takeover-plan`, takeoverPlanRequested);

        return true;
      }

      return false;
    }
  }
})

</script>



<style scoped lang="scss">

#participants {
  width: 60px
}

#original-effective-date, #takeover-date {
  padding-top: 13px
}

</style>



// WEBPACK FOOTER //
// src/employer/EmployerTakeoverPlans.vue